import { c as _c } from "react/compiler-runtime";
import style from "./Lists.module.scss";
import GenericListRow, { ListRow } from "./GenericListRow";
import React, { ReactElement, ReactNode } from "react";
export type Props<T> = {
  title: string;
  headers: {
    label: string;
    width?: string;
    align?: "right";
  }[];
  supplementalInformation?: string | ReactNode;
  rows: ListRow<T>[];
  emptyPlaceholder: ReactNode;
  proportions: number[];
  expandable?: boolean;
  supplementalOnMobile?: boolean;
  linedRows?: boolean;
  children?: ReactElement;
};
export const GenericList = t0 => {
  const $ = _c(30);
  const {
    headers,
    title,
    supplementalInformation,
    rows,
    emptyPlaceholder,
    proportions,
    expandable,
    supplementalOnMobile: t1,
    linedRows: t2,
    children
  } = t0;
  const supplementalOnMobile = t1 === undefined ? false : t1;
  const linedRows = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== expandable || $[1] !== rows) {
    t3 = rows.some(_temp) || expandable;
    $[0] = expandable;
    $[1] = rows;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const hasActions = t3;
  const t4 = supplementalOnMobile ? style.supplementalOnMobile : "";
  const t5 = linedRows ? style.linedRows : "";
  let t6;
  if ($[3] !== t4 || $[4] !== t5) {
    t6 = [style.gridContainer, t4, t5];
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = t6.join(" ");
  let t8;
  if ($[6] !== proportions) {
    t8 = proportions.map(_temp2).join(" ");
    $[6] = proportions;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = `${t8}`;
  let t10;
  if ($[8] !== t9) {
    t10 = {
      gridTemplateColumns: t9
    };
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== title) {
    t11 = <h3 data-cy="generic-list-header-title">{title}</h3>;
    $[10] = title;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== supplementalInformation || $[13] !== t11) {
    t12 = <section className={style.header} data-cy="generic-list-header">{t11}{supplementalInformation}</section>;
    $[12] = supplementalInformation;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== emptyPlaceholder || $[16] !== expandable || $[17] !== hasActions || $[18] !== headers || $[19] !== rows) {
    t13 = rows.length > 0 ? <table className={style.table} data-cy="generic-list-table"><thead><tr>{headers.map((header, i) => <th key={header.label} style={{
            width: header.width ?? "auto"
          }} colSpan={hasActions && i === headers.length - 1 ? 2 : 1} align={header.align ?? "left"}>{header.label}</th>)}</tr></thead>{rows.map(row_0 => <GenericListRow key={row_0.id} row={row_0} expandable={expandable} />)}</table> : <div data-cy="generic-list-empty-placeholder">{emptyPlaceholder}</div>;
    $[15] = emptyPlaceholder;
    $[16] = expandable;
    $[17] = hasActions;
    $[18] = headers;
    $[19] = rows;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== children || $[22] !== t13) {
    t14 = <section>{t13}{children}</section>;
    $[21] = children;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t10 || $[25] !== t12 || $[26] !== t14 || $[27] !== t7 || $[28] !== title) {
    t15 = <div className={t7} style={t10} key={title} data-cy="generic-list">{t12}{t14}</div>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t14;
    $[27] = t7;
    $[28] = title;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
};
function _temp(row) {
  return typeof row.contextOptions !== "undefined";
}
function _temp2(p) {
  return p.toString() + "%";
}